export default [
  {
    path: "/bind/:projectId",
    name: "bind",
    meta: {
      title: "用户测评",
      auth: true
    },
    component: () => import("@views/evaluate/Bind")
  },
  {
    path: "/eval/register/:projectId",
    name: "register",
    meta: {
      title: "用户信息",
      auth: true
    },
    component: () => import("@views/evaluate/Register")
  },
  {
    path: "/eval/start/:projectId",
    name: "eval-start",
    meta: {
      title: "开始测评",
      auth: true
    },
    component: () => import("@views/evaluate/Answering")
  },
  {
    path: "/eval/start/team/:projectId",
    name: "eval-team-start",
    meta: {
      title: "团队角色测评",
      auth: true
    },
    component: () => import("@views/evaluate/TeamAnswer")
  },
  {
    path: "/eval/post/:projectId",
    name: "eval-post",
    meta: {
      title: "胜任力岗位选择",
      auth: true
    },
    component: () => import("@views/evaluate/Post")
  },
  {
    path: "/eval/process/:projectId",
    name: "eval-process",
    meta: {
      title: "测评进度",
      auth: true
    },
    component: () => import("@views/evaluate/Process")
  },
  {
    path: "/eval/result/:projectId",
    name: "eval-finish",
    meta: {
      title: "恭喜完成答题",
      auth: true
    },
    component: () => import("@views/evaluate/Result")
  },
  {
    path: "/eval/pay/:projectId",
    name: "eval-pay",
    meta: {
      title: "支付",
      auth: true
    },
    component: () => import("@views/evaluate/Pay")
  },
];
